import { useContext, type ReactElement } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { DefaultLayout } from "../layout/DefaultLayout";
import { AuthContext } from "../context/AuthContext";
import {
  About,
  FAQ,
  PerguntasFrequentes,
  Home,
  MetadataCatalog,
  MetadataDetail,
  MetadataCatalogByCategory,
  Login,
  SendPasswordRecoveryEmail,
  RecoveryPassword,
  AdminLayers,
  RegistrationRequest,
  FaleConosco,
  ProjecaoCustomizada,
  AreasPropicias,
} from "../pages";
import {
  CATEGORY_METADATA_ROUTE,
  DETAIL_METADATA_ROUTE,
  METADATA_ROUTE,
} from "../global/constants/routes/metadataConstants";
import { RECOVERY_PASSWORD_ROUTE } from "../global/constants/routes/userConstants";
import {
  FALE_CONOSCO_ROUTE,
  REGISTRATION_REQUEST_ROUTE,
} from "../global/constants/routes/defaultConstants";

export const ADMIN_ROUTE = "/admin";
const LOGIN_PAGE_ROUTE = "/login";

export function Router() {
  const { signed, user } = useContext(AuthContext);
  const canAccessHelpRoutes = signed && Boolean(user);

  const requireLoggedUser = (element: ReactElement) => {
    if (canAccessHelpRoutes) return element;
    return <Navigate to={LOGIN_PAGE_ROUTE} replace />;
  };

  const faqElement = requireLoggedUser(<FAQ />);
  const frequentQuestionsElement = requireLoggedUser(<PerguntasFrequentes />);

  return (
    <Routes>
      {signed && (
        <>
          <Route path="/" element={<DefaultLayout />}>
            <Route path="/" element={<Home />} />
            <Route
              path={METADATA_ROUTE}
              element={signed ? <MetadataCatalog /> : <Login />}
            />
            <Route
              path={DETAIL_METADATA_ROUTE(":pk")}
              element={<MetadataDetail />}
            />
            <Route
              path={CATEGORY_METADATA_ROUTE(":category")}
              element={<MetadataCatalogByCategory />}
            />
            <Route path="/duvidas" element={faqElement} />
            <Route
              path="/perguntas-frequentes"
              element={frequentQuestionsElement}
            />
            <Route path="/sobre" element={<About />} />
            {/* AdminLayers faz a checagem de admin e redireciona quem não é */}
            <Route
              path={ADMIN_ROUTE}
              element={requireLoggedUser(<AdminLayers />)}
            />
            <Route path="/projecao-customizada" element={<ProjecaoCustomizada />} />
            <Route path="/areas-propicias" element={<AreasPropicias />} />
          </Route>
          {/* <Route path="/" element={<FormPageLayout />}>
            <Route path={INVITE_USER_ROUTE} element={<InviteUser />} />
          </Route> */}
        </>
      )}
      {!signed && (
        <>
          <Route path="/duvidas" element={requireLoggedUser(<FAQ />)} />
          <Route
            path="/perguntas-frequentes"
            element={requireLoggedUser(<PerguntasFrequentes />)}
          />
          <Route
            path={ADMIN_ROUTE}
            element={requireLoggedUser(<AdminLayers />)}
          />
        </>
      )}
      <Route path="/">
        <Route path={"/login"} element={<Login />} />
        <Route path={"/"} element={<Login />} />
        <Route
          path={RECOVERY_PASSWORD_ROUTE()}
          element={<SendPasswordRecoveryEmail />}
        />
        <Route
          path={RECOVERY_PASSWORD_ROUTE(":token")}
          element={<RecoveryPassword />}
        />
        <Route
          path={REGISTRATION_REQUEST_ROUTE}
          element={<RegistrationRequest />}
        />
        <Route path={FALE_CONOSCO_ROUTE} element={<FaleConosco />} />
      </Route>
    </Routes>
  );
}
